<template>
  <div class="navbar">
    <hamburger
      :is-active="sidebar.opened"
      class="hamburger-container"
      @toggleClick="toggleSideBar"
    />
    <breadcrumb class="breadcrumb-container" />
    <div class="right-menu" v-if="accountType != 'zhilingji'">
      <el-dropdown
        class="messBox"
        trigger="click"
        :disabled="messagesList.length < 1"
        v-if="roles.includes('/admin_messages/lists')"
      >
        <span class="el-dropdown-link">
          <el-badge :is-dot="messagesList.length != 0" class="item">
            <i style="font-size: 25px" class="el-icon-bell"></i>
          </el-badge>
        </span>
        <el-dropdown-menu
          slot="dropdown"
          class="mess-dropdown infinite-list"
          style="top: 45px; max-height: 308px; overflow: auto; max-width: 500px"
          v-infinite-scroll="load"
        >
          <el-dropdown-item
            @click.native="read(item)"
            :divided="true"
            :key="index"
            v-for="(item, index) in messagesList"
            ><span class="line2"> {{ item.content }}</span></el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>

      <el-dropdown class="avatar-container" trigger="click">
        <div class="avatar-wrapper">
          <img v-if="pric" :src="imageUrl + pric" class="user-avatar" />
          <img v-else src="@/static/headImg.png" class="user-avatar" />
          <span>{{ userInfo.username }}</span>
          <i class="el-icon-caret-bottom" />
        </div>
        <el-dropdown-menu slot="dropdown" class="user-dropdown">
          <router-link to="/">
            <el-dropdown-item> 首页 </el-dropdown-item>
          </router-link>
          <a @click="editPass">
            <el-dropdown-item>修改密码</el-dropdown-item>
          </a>
          <el-dropdown-item divided @click.native="logout">
            <span style="display: block">退出登录</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <el-dialog
      title="修改密码"
      :visible.sync="dialogVisible"
      width="30%"
      center
      :close-on-click-modal="false"
    >
      <el-input
        v-model="user.password"
        placeholder="请输入登录密码"
        style="margin-bottom: 8px"
      ></el-input>
      <el-input
        v-model="user.repassword"
        placeholder="请输入确认密码"
      ></el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="edit">确 定</el-button>
      </span>
    </el-dialog>
    <audio id="audio" src="../../assets/notice.mp3"></audio>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import { editMyPass } from "@/api/user";
// import { ws } from "@/utils/websocket";
import { messagesLists, messagesInfo } from "@/api/index";
export default {
  components: {
    Breadcrumb,
    Hamburger,
  },
  data() {
    return {
      dialogVisible: false,
      pric: this.$store.state.user.picture,
      user: {
        password: "",
        repassword: "",
      },
      accountType: localStorage.getItem("zhType"),
      messagesList: [
      ],
      page_size:15,
      page:1
    };
  },
  computed: {
    ...mapGetters(["roles","sidebar", "avatar", "imageUrl", "userInfo"]),
  },
  mounted() {
    // ws.onmessage = (e) => {
    //   ws.getMess(e);
    //   if (JSON.parse(e.data).type == "push") {
    //     var Music = document.getElementById("audio");
    //     Music.play();
    //     this.getList();
    //   }
    // };
  },
  watch: {},
  created() {
    if(this.roles.includes('/admin_messages/lists')){
      this.getList();
    }
  },
  methods: {
    load(){
      this.page ++
      this.getList();
    },
    ccc() {
      var Music = document.getElementById("audio");
      Music.play();
    },
    read(e) {
      // console.log(this.$route.path)
      // return
      // console.log(e);
      var that = this;
      messagesInfo({
        uid: localStorage.getItem("userId"),
        message_id: e.id,

      }).then((res) => {
        console.log(res);
        this.getList();
      });
      if (e.source == 1) {
        // 车位相关
        if (this.$route.path == "/parkingManage/applyList") {
          location.reload();
        } else {
          this.$router.push(`/parkingManage/applyList`);
        }
      } else if (e.source == 2) {
        // 报事相关
        if (this.$route.path == "/repairs/index") {
          location.reload();
        } else {
          this.$router.push(`/repairs/index`);
        }
      } else if (e.source == 3) {
        //  装修相关
        if (this.$route.path == "/renovation/applyList") {
          location.reload();
        } else {
          this.$router.push(`/renovation/applyList`);
        }
      } else if (e.source == 4) {
        // 物业服务相关
        if (this.$route.path == "/property/orderLists") {
          location.reload();
        } else {
          this.$router.push(`/property/orderLists`);
        }
      } else if (e.source == 5) {
        // 企业员工相关
        if (this.$route.path == "/enterprise/applyList") {
          location.reload();
        } else {
          this.$router.push(`/enterprise/applyList`);
        }
      }
    },

    getList() {
      messagesLists({ uid: localStorage.getItem("userId"), is_page: 1,page_size:15,page:this.page }).then(
        (res) => {
          if(this.page  != 1){
            this.messagesList = this.messagesList.concat(res.data.data);
          }else{
            this.messagesList = res.data.data
          }
        }
      );
    },

    edit() {
      this.user.id = this.userInfo.id;
      editMyPass(this.user).then((res) => {
        if (res.code == 200) {
          this.$message({
            message: res.msg,
            type: "success",
          });
          window.localStorage.clear();
          // 状态保持清除后刷新页面
          window.location.reload();
          this.$router.push(`/login`);
        }
      });
    },
    editPass() {
      this.user.id = this.userInfo.id;
      this.dialogVisible = true;
    },
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },
    async logout() {
      await this.$store.dispatch("user/logout");
      // window.localStorage.clear();
      // // 状态保持清除后刷新页面
      // window.location.reload();
      // this.$router.push(`/login?redirect=${this.$route.fullPath}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 50px;
  overflow: hidden;
  position: relative;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);

  .hamburger-container {
    line-height: 46px;
    height: 100%;
    float: left;
    cursor: pointer;
    transition: background 0.3s;
    -webkit-tap-highlight-color: transparent;

    &:hover {
      background: rgba(0, 0, 0, 0.025);
    }
  }

  .breadcrumb-container {
    float: left;
  }

  .right-menu {
    float: right;
    height: 100%;
    line-height: 50px;

    &:focus {
      outline: none;
    }

    .right-menu-item {
      display: inline-block;
      padding: 0 8px;
      height: 100%;
      font-size: 18px;
      color: #5a5e66;
      vertical-align: text-bottom;

      &.hover-effect {
        cursor: pointer;
        transition: background 0.3s;

        &:hover {
          background: rgba(0, 0, 0, 0.025);
        }
      }
    }

    .avatar-container {
      margin-right: 30px;

      .avatar-wrapper {
        margin-top: 5px;
        position: relative;
        display: flex;
        align-items: center;
        .user-avatar {
          cursor: pointer;
          width: 32px;
          height: 32px;
          border-radius: 10px;
          margin-right: 8px;
        }

        .el-icon-caret-bottom {
          cursor: pointer;
          position: absolute;
          right: -20px;
          // top: 25px;
          font-size: 12px;
        }
      }
    }
  }
}
.messBox {
  margin-right: 30px;
  position: relative;
  top: -7px;
  ::v-deep .el-badge__content.is-fixed {
    top: 8px;
  }
  .mess-dropdown {
    top: 45px;
  }
}
</style>
